const SELECTOR_COMPONENT = 'buchhaendler-bewertung';
const SELECTOR_BTN_MORE = '.bewertungen-more';
const SELECTOR_BEWERTUNGEN_CONTAINER = '.bewertungen-container';
const SELECTOR_BEWERTUNGEN_TOTAL_COUNT = '.bewertungen-total-elements';
const SELECTOR_ALLE_BEWERTUNGEN = 'buchhaendler-bewertung';

const CLASS_BTN_MORE_HIDDEN = 'bewertungen-more-hidden';

const BEWERTUNGEN_CONTAINER_MIN_HEIGHT_CLASS = 'bewertungen-container--min-height';

const DEFAULT_PAGE_SIZE = 10;

class BuchhaendlerBewertungsliste extends HTMLElement {
  constructor() {
    super();
    this.queryParamMap = new Map();
    this.filterAndSortChanged = false;
    this.initPageStatus();
  }

  initPageStatus() {
    this.nextPage = 0;
    this.totalElements = null;
    this.initialLoad = true;
  }

  connectedCallback() {
    this.removeHiddenAttributes();
    this.setAnzahlBewertungen();
    this.initScrollBehavior();
    this.setComponents();
    this.loadBewertungen();
    this.bindEvents();
  }

  removeHiddenAttributes() {
    this.querySelectorAll('[hidden]').forEach(el => {
      el.removeAttribute('hidden');
    });
  }

  setAnzahlBewertungen() {
    const anzahlBewertungen = this.querySelectorAll(`${SELECTOR_BEWERTUNGEN_CONTAINER} ${SELECTOR_ALLE_BEWERTUNGEN}`).length;
    this.querySelector('.bewertungen-displayed-elements').innerText = anzahlBewertungen;
  }

  initScrollBehavior() {
    document.body.style.overflowAnchor = 'none';

    if (history.scrollRestoration) {
      history.scrollRestoration = 'manual';
    }
  }

  setComponents() {
    this.buttonMore = this.querySelector(SELECTOR_BTN_MORE);
    this.bewertungenContainer = this.querySelector(SELECTOR_BEWERTUNGEN_CONTAINER);
    this.bewertungenTotalElements = this.querySelectorAll(SELECTOR_BEWERTUNGEN_TOTAL_COUNT);
  }

  bindEvents() {
    this.buttonMore.addEventListener('click', () => this.onMoreButtonClicked());
    document.addEventListener('bewertungs-filter-and-sort-changed', event => this.onFilterAndSortChanged(event.detail));
  }

  onMoreButtonClicked() {
    this.loadBewertungen();
    this.buttonMore.blur();
  }

  setButtonVisibility() {
    if (this.nextPage != null) {
      this.buttonMore.classList.remove(CLASS_BTN_MORE_HIDDEN);
    } else {
      this.buttonMore.classList.add(CLASS_BTN_MORE_HIDDEN);
    }
  }

  loadBewertungen() {
    if (this.nextPage != null) {
      this.setButtonLoadingState(true);
      const url = this.buildUrlWithFilterAndSorting();

      fetch(url)
          .then(response => {
            if (!response.ok) {
              throw response;
            }
            return response.text();
          })
          .then((text) => {
            this.handleResult(text);
            this.setButtonLoadingState(false);
            this.setAnzahlBewertungen();
          })
          .catch((err) => {
            console.error(err);
            this.setButtonLoadingState(false);
          });
    }
  }

  buildUrlWithFilterAndSorting() {
    let baseUrl = `${location.origin}${location.pathname}`;
    let pageParam = `page=${this.nextPage}`;
    let sizeParam = `size=${DEFAULT_PAGE_SIZE}`;
    let url = `${baseUrl}/bewertungsseite?${pageParam}&${sizeParam}`;
    url = this.appendFilterAndSortUrlPart(url);
    return url;
  }

  appendFilterAndSortUrlPart(url) {
    if (this.queryParamMap.size > 0) {
      let filterAndSortPart = '';
      this.queryParamMap.forEach((value, key) => {
        if (value.size > 0) {
          filterAndSortPart += `&${key}=${encodeURIComponent(Array.from(value).join(','))}`;
        }
      });
      url += filterAndSortPart;
    }
    return url;
  }

  handleResult(responseText) {
    const responseHtml = document.createElement('bewertungs-seite');
    responseHtml.innerHTML = responseText;

    this.updatePageInfos(responseHtml);

    const bewertungen = responseHtml.querySelectorAll(SELECTOR_COMPONENT);

    if (this.filterAndSortChanged === true) {
      this.bewertungenContainer.classList.add(BEWERTUNGEN_CONTAINER_MIN_HEIGHT_CLASS);
      this.bewertungenContainer.innerHTML = '';
      this.filterAndSortChanged = false;
    }

    bewertungen.forEach((node) => this.bewertungenContainer.appendChild(node));

    if (this.initialLoad === true) {
      this.bewertungenContainer.classList.remove(BEWERTUNGEN_CONTAINER_MIN_HEIGHT_CLASS);
    }

    this.initialLoad = false;
  }

  updatePageInfos(responseHtml) {
    const containerElement = responseHtml.querySelector('[data-total-elements]');

    this.updateNextPageInfo(containerElement);
    if (this.initialLoad === true) {
      this.updateTotalCount(containerElement);
    }
  }

  updateTotalCount(containerElement) {
    const totalElements = containerElement.dataset.totalElements;
    this.bewertungenTotalElements.forEach(element => element.innerText = totalElements);

    if (this.filterAndSortChanged === false) {
      this.sendTotalCountEvent(totalElements);
    }
  }

  updateNextPageInfo(containerElement) {
    const dataNextPage = containerElement.dataset.nextPage;
    this.nextPage = dataNextPage ? dataNextPage : null;
    this.setButtonVisibility();
  }

  setButtonLoadingState(isLoading) {
    if (isLoading) {
      this.buttonMore.dataset.loading = true;
      this.buttonMore.disabled = true;
    } else {
      this.buttonMore.removeAttribute('data-loading');
      this.buttonMore.removeAttribute('disabled');
    }

  }

  sendTotalCountEvent(totalElements) {
    const totalCountEvent = new CustomEvent('total-bewertungen', {detail: totalElements});
    document.dispatchEvent(totalCountEvent);
  }

  onFilterAndSortChanged(queryParamMap) {
    this.queryParamMap = queryParamMap;
    this.filterAndSortChanged = true;
    this.initPageStatus();
    this.loadBewertungen();
  }

}

if (!customElements.get("buchhaendler-bewertungsliste")) {
  customElements.define("buchhaendler-bewertungsliste", BuchhaendlerBewertungsliste);
}